import React from 'react';
import TelegramWidget from '../../../telegramWidget/TelegramWidget';
import './scss/AsapLive.scss';

const AsapLive = () => {
    const socials = [
        {
            social_name: 'vk',
            social_description: 'Наша группа в VK',
            social_link: 'https://vk.com/asap_it',
            social_icon: 'https://admin.asap-ag.ru/uploads/Vector_c01df56fdc.svg',
        },
        {
            social_name: 'telegram',
            social_description: 'Телеграм-канал агентства',
            social_link: 'https://t.me/asap_agency',
            social_icon: 'https://admin.asap-ag.ru/uploads/Subtract_502cc11613.svg',
        },
        {
            social_name: 'telegram',
            social_description: 'Телеграм-канал CEO ASAP',
            social_link: 'https://t.me/vasilievit',
            social_icon: 'https://admin.asap-ag.ru/uploads/Subtract_502cc11613.svg',
        },
    ]

    return (
        <section className="media-section" data-aos="fade-up">
            <div className="wrapper">
                <div className="media-section__left">
                    <div className="media-section__top">
                        <span className="media-section__title label-text">Медиа</span>
                        <div className="media-section__circle"></div>
                    </div>
                    <div className="media-section__foot">
                        {socials.map((social) => (
                            <a href={social.social_link} target="_blank" key={social.id} className="media-social">
                                <div className="media-social__head">
                                    <span className="h3 media-social__name">{social.social_name}</span>
                            
                                    <img
                                        alt={social.social_name}
                                        width={24}
                                        height={24}
                                        src={social.social_icon}
                                    />
                                </div>
                                <div className="media-social__foot">
                                    {social.social_description &&
                                        <span className="label-text media-social__label">{social.social_description}</span>
                                    }
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
                <div className="media-section__right">
                    <TelegramWidget/>
                </div>
            </div>
        </section>
    )
}

export default AsapLive